<script>
    /** @type{number} */
    export let orderId;
</script>

<div class="flex flex-col h-screen justify-center items-center bg-white p-12">
    <h1 class="text-center text-3xl font-semibold mb-6">Поръчката е потвърдена</h1>
    <div class="text-xl mb-4">
        <span class="font-medium">Номер на поръчката:</span> {orderId}
    </div>
    <div class="text-gray-600 mb-6">
        <p>Скоро ще получите потвърждаващо обаждане за проверка на поръчката ви и информация за доставката.</p>
        <p class="mt-2">Екипът ни ще подготви артикулите за доставка.</p>
        <p class="mt-2">За въпроси или промени, моля, посочете номера на поръчката си.</p>
    </div>
    <div class="text-sm text-gray-500 border-t pt-6">
        <p>Имате нужда от помощ? Свържете се с нас:</p>
        <p class="mt-2"><i class="fas fa-phone-alt mr-2"></i> 0879399088</p>
        <p class="mt-2"><i class="fas fa-envelope mr-2"></i> malkotohanche@gmail.com</p>
    </div>
</div>
